import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { MustMatch } from '../password-creation/must-match.validator';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/service/user.service';
// import { User } from 'src/app/models/user';
import { User } from 'src/app/models/user';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-forgot-password-page',
  templateUrl: './forgot-password-page.component.html',
  styleUrls: ['./forgot-password-page.component.css']
})
export class ForgotPasswordPageComponent implements OnInit {
  secQuesTriggerForm!: UntypedFormGroup
  newPasswordForm!: UntypedFormGroup
  isSubmitted = false;
  showDetails = false;
  reqJson: any;
  userDetails: User = new User;
  questionPolicyLength: any
  passwordPolicyMap: any
  loginName: any;
  meetingId: any;
  isGuestUser: any;
  ifSecQuestionAvail = true;
  userInfo: any;
  forgotPasswordEmail: any;
  passExpLabel: any;
  onStrengthChanged(strength: any) {

  }

  toggler(e: any) {
    this.showDetails = e
  }

  private readonly notifier!: NotifierService;
  constructor(private router: Router, private activatedroute: ActivatedRoute, private notifierService: NotifierService, private formBuilder: UntypedFormBuilder, private userService: UserService, private spinner: NgxSpinnerService) {
    this.notifier = notifierService;
    this.activatedroute.queryParams.subscribe(
      (params: any) => {
        // this.userInfo=params;
        this.userInfo = JSON.parse(params.userInfo);
        this.passwordPolicyMap = this.userInfo.userInfo.pwdPolicyMap;
        if (this.userInfo.errMsg == "PASSWORDEXPIRED") {
          this.passExpLabel = "Your password has not been changed for 90 days. Please change your password.";
        }
        //  this.forgotPasswordEmail = params.userInfo.email
      });


  }

  ngOnInit(): void {
    if (this.userInfo.email != null && this.userInfo.email != undefined) {
      this.ifSecQuestionAvail = this.userInfo.email
    }
    this.newPasswordForm = this.formBuilder.group({
      // title: ['', Validators.required],
      //validator for password with lower case, uppercase, special charters and numbers and minimum length should be 6 
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.pattern('((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,30})'), Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]
    }, {
      validator: MustMatch('newPassword', 'confirmPassword')
    })
    this.secQuesTriggerForm = this.formBuilder.group({
      // title: ['', Validators.required],
      //validator for password with lower case, uppercase, special charters and numbers and minimum length should be 6 
      password: ['', [Validators.required, Validators.pattern('((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,30})'), Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]
    }, {
      validator: MustMatch('password', 'confirmPassword')
    })
  }

  get f() {
    return this.newPasswordForm.controls;
  }

  get j() {
    return this.secQuesTriggerForm.controls;
  }

  public checkPasswordReg = (controlName: string, errorName: string) => {
    return this.secQuesTriggerForm.controls[controlName].hasError(errorName)
  }

  public newPasswordReg = (controlName: string, errorName: string) => {
    return this.newPasswordForm.controls[controlName].hasError(errorName)
  }

  submitNewPassword() {

    var reqJson = {
      "loginName": this.userInfo.userInfo.loginName,
      "oldPassword": this.newPasswordForm.controls['oldPassword'].value,
      "password": this.newPasswordForm.controls['confirmPassword'].value,
      "changePasswordFlag": 1
    }

    if (this.newPasswordForm.invalid) {
      this.isSubmitted = false;
      this.notifier.show({
        type: 'error',
        message: 'Invalid Form'
      });
      this.spinner.hide();
      return;
    }

    this.userService.updatePasswordDetails(reqJson).subscribe((data: any) => {
      this.userDetails = data.body;
      if (this.userDetails.errorMessage != undefined && this.userDetails.errorMessage !== null && this.userDetails.errorMessage != "") {
        this.notifier.show({
          type: 'error',
          message: this.userDetails.errorMessage
        });
      } else {
        this.notifier.show({
          type: 'success',
          message: 'Password changed successfully'
        });
        this.router.navigate(['']);
      }
    });
  }

  secQuesTriggerFormSubmission() {

    this.reqJson = {
      "loginName": this.userInfo.userInfo.loginName,
      "password": this.secQuesTriggerForm.controls['confirmPassword'].value,
      "newPasswordFlag": 1
    }

    if (this.secQuesTriggerForm.invalid) {
      this.isSubmitted = false;
      this.notifier.show({
        type: 'error',
        message: 'Invalid Form'
      });
      this.spinner.hide();
      return;
    }


    this.userService.updatePasswordDetails(this.reqJson).subscribe((data: any) => {
      this.userDetails = data.body;
      if (this.userDetails.errorMessage != undefined && this.userDetails.errorMessage !== null && this.userDetails.errorMessage != "") {
        this.notifier.show({
          type: 'error',
          message: this.userDetails.errorMessage
        });
      } else {
        this.notifier.show({
          type: 'success',
          message: 'Password changed successfully'
        });
        this.router.navigate(['']);
      }
    });

  }

}
